import Constants from '../Constants.js';

/**
 * This is meant to be a generic, reusable user action generator.
 * It needs the resourceId.
 * <code>
 * user : ( userId ) => {
 *   return new User( {
 *     userId,
 *     resourceId : this.id, // with is th device, system, project, script, etc id
 *     resourceApi : ( dispatch, getState, opts, resourceId ) => {
 *       // this return's a the api on which the user's calls exist
 *       return opts.api.resource( resourceId )
 *     }
 *   })
 * }
 */
class ResourceUser {
  constructor({
    userId,
    resourceId,
    resourceApi
  }) {
    this.resourceApi = resourceApi;
    this.resourceId = resourceId;
    this.userId = userId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      dispatch({
        type: Constants.RESOURCE_USER_STATUS,
        resourceId: this.resourceId,
        userId: this.userId,
        status
      });
      const api = this.resourceApi(dispatch, getState, opts, this.resourceId);
      // override top level api with resource api
      return func(dispatch, getState, {
        ...opts,
        api
      }, this.resourceId).catch(error => {
        dispatch({
          type: Constants.RESOURCE_USER_STATUS,
          resourceId: this.resourceId,
          userId: this.userId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  get(opts) {
    return this.createAction('load', 'loading', async (dispatch, getState, {
      api
    }, resourceId) => {
      const {
        requestId,
        ...reqOpts
      } = opts || {};
      const r = await api.user(this.userId).get(reqOpts);
      dispatch({
        type: Constants.RESOURCE_USER_GET,
        resourceId,
        user: r,
        requestId
      });
      return r;
    });
  }
  roles(opts) {
    return this.createAction('loadRoles', 'loadingRoles', async (dispatch, getState, {
      api
    }, resourceId) => {
      const r = await api.user(this.userId).roles(opts);
      dispatch({
        type: Constants.RESOURCE_USER_UPDATE_ROLES,
        resourceId,
        userId: this.userId,
        roles: r.items
      });
      return r;
    });
  }

  // update( update ) {
  //   return this.api.patchRaw( update )
  // }

  // delete( ) {
  //   return this.api.delete( )
  // }

  addRole(role) {
    return this.addRoles(role);
  }

  /**
   * Either a role id, or array of role ids
   */
  addRoles(role) {
    return this.createAction('addRoles', 'addingRoles', async (dispatch, getState, {
      api
    }, resourceId) => {
      let r = await api.user(this.userId).addRoles(role);
      if (!Array.isArray(r)) {
        r = [r];
      }
      // Might not have the role info, as adding a role doesnt return it..
      const roles = await api.user(this.userId).roles();
      dispatch({
        type: Constants.RESOURCE_USER_UPDATE_ROLES,
        resourceId,
        userId: this.userId,
        roles: roles.items
      });

      // dispatch( { type : Constants.RESOURCE_USER_ADD_ROLES, resourceId, userId : this.userId, roles : r } )
      return r;
    });
  }
  removeRole(role) {
    return this.removeRoles(role);
  }

  /**
   * Either a role id, or array of role ids
   */
  removeRoles(role) {
    return this.createAction('removeRoles', 'removingRoles', async (dispatch, getState, {
      api
    }, resourceId) => {
      let r = await api.user(this.userId).removeRole(role);
      if (!Array.isArray(r)) {
        r = [r];
      }
      const roles = await api.user(this.userId).roles();
      dispatch({
        type: Constants.RESOURCE_USER_UPDATE_ROLES,
        resourceId,
        userId: this.userId,
        roles: roles.items
      });

      // dispatch( { type : Constants.RESOURCE_USER_REMOVE_ROLES, resourceId, userId : this.userId, roles : r } )
      return r;
    });
  }
  removeAllRoles() {
    return this.createAction('removeAllRole', 'removingAllRole', async (dispatch, getState, {
      api
    }, resourceId) => {
      const r = await api.user(this.userId).removeAllRoles();
      dispatch({
        type: Constants.RESOURCE_USER_UPDATE_ROLES,
        resourceId,
        userId: this.userId,
        roles: []
      });
      return r;
    });
  }
}
export default ResourceUser;